import React from 'react';
import Loadable from 'react-loadable';
import Loading from '../components/OrganizationSignup2/Loading';
import ApolloProviderWrapper from 'appDir/lib/apollo/ApolloProviderWrapper';
import { ToastContainer } from 'react-toastify';

const LoadableComponent = Loadable({
  loader: () => import('appDir/containers/ParentSettingsContainer'),
  loading: Loading,
});

const ParentSettingsApp = (props, context) => {
  return (
    <ApolloProviderWrapper railsContext={context}>
      <ToastContainer
        hideProgressBar
        closeButton={false}
        pauseOnHover={false}
        pauseOnFocusLoss={false}
        autoClose={3500}
      />
      <LoadableComponent {...props} />
    </ApolloProviderWrapper>
  );
};

export default ParentSettingsApp;
